export default "/images/7678a02b5571c6e52e5ef86d8f35849b.avif";